/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import PageTitle from '../../../Layout/PageTitle';
import Jobfindbox from '../../../Element/Jobfindbox';

//Images
import bnr from '../../../../images/banner/bnr1.jpg';
import axiosInstance from '../../../../services/AxiosInstance';


function Browsejoblist() {

	const { filter } = useParams();
	let apifilters = '';
	if (filter) {
		const decoded = atob(filter);
		const filterObj = JSON.parse(decoded);
		apifilters = `?job_status__in=a&category__id__in=${filterObj?.job_categories}&search=${filterObj?.title}&search=${filterObj?.place}&search=${filterObj?.place}`;
	}

	const [jobs, setJobs] = useState([])
	const [input, setInput] = useState({
		title: '',
		place: '',
		job_categories: ''
	});
	const [categories, setCategories] = useState();

	var image = require("../../../../images/logo/icon1.png")

	useEffect(() => {
		axiosInstance('job-categories/?fields=id,name', { method: "GET" })
			.then(res => { if (res?.status === 200) setCategories(res?.data?.results) })
		getData();
	}, [])

	const handleInput = (e, dr) => {
		if (dr) {
			var option = document.getElementById("cities").value
			setInput({ ...input, 'job_categories': option })
		}
		else setInput({ ...input, [e.target.name]: e.target.value })
	}

	const getData = (url) => {
		let lurl = url ? url + apifilters : 'post-jobs/' + apifilters;
		axiosInstance(
			lurl, {
			method: "GET"
		}).then(res => {
			setJobs(res?.data);
		}).catch(err => {
			console.log('err : ', err)
		})
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		let lurl = `post-jobs/?job_status__in=a&category__id__in=${input?.job_categories}&search=${input?.title}&search=${input?.place}&search=${input?.place}`;
		axiosInstance(
			lurl, {
			method: "GET"
		}).then(res => {
			setJobs(res?.data);
		}).catch(err => {
			console.log('err : ', err)
		})
	}

	return (
		<>
			<div className="page-content bg-white">
				<div className="dez-bnr-inr overlay-black-middle" style={{ backgroundImage: "url(" + bnr + ")" }}>
					<PageTitle motherName="Home" activeName="Browse Job List" />
				</div>
				<Jobfindbox
					categories={categories}
					input={input}
					handleInput={handleInput}
					handleSubmit={handleSubmit}
				/>
				<div className="content-block">
					<div className="section-full browse-job p-b50">
						<div className="container">
							<div className="row">
								<div className="col-xl-12 col-lg-12 col-md-12">
									<div className="job-bx-title clearfix">
										<h5 className="font-weight-700 pull-left text-uppercase">{jobs?.pagination?.totalEntries} Jobs Found</h5>
									</div>
									<ul className="post-job-bx">
										{!(jobs?.results?.length) && <div className="text-center">No records found</div>}
										{jobs?.results?.map((res, index) => {
											return (
												<li key={index}>
													<div className="post-bx">
														<div className="d-flex m-b30">
															<div className="job-post-company">
																<Link to={"#"}><span>
																	<img alt="" src={image} />
																</span></Link>
															</div>
															<div className="job-post-info">
																<h4><Link to={`/job-detail/${res.id}`}> {res.title?.name} </Link></h4>
																<ul>
																	<li><i className="fa fa-map-marker"></i> {res.country?.name}</li>
																	<li><i className="fa fa-bookmark-o"></i> Full Time</li>
																	<li><i className="fa fa-user"></i> Vacancies - {res.vacancies}</li>
																</ul>
															</div>
														</div>
														<div className="d-flex">
															<div className="job-time mr-auto">
																<span>Experience: {parseInt(res.min_experience)}years - {parseInt(res.max_experience)}years</span>
															</div>
															<div className="salary-bx">
																<span>Salary: {parseInt(res.min_salary)} - {parseInt(res.max_salary)}</span>
															</div>
														</div>
														{/* <label className="like-btn">
														<input type="checkbox" />
														<span className="checkmark"></span>
													</label> */}
													</div>
												</li>
											)
										})}
									</ul>
									{/* <div className="pagination-bx m-t30">
										<ul className="pagination">
											<li className="previous"><Link to={"#"}><i className="ti-arrow-left"></i> Prev</Link></li>
											<li className="active"><Link to={"#"}>1</Link></li>
											<li><Link to={"#"}>2</Link></li>
											<li><Link to={"#"}>3</Link></li>
											<li className="next"><Link to={"#"}>Next <i className="ti-arrow-right"></i></Link></li>
										</ul>
									</div> */}
									<div className="m-t30">
										<div className="d-flex">
											<button
												className="site-button button-sm mr-auto"
												disabled={jobs.pagination?.previous ? false : true}
												onClick={() => getData(jobs?.pagination?.previous)}
												style={{ backgroundColor: jobs.pagination?.previous ? "#1d46f5" : "#8b99d5", cursor: jobs.pagination?.previous ? "pointer" : "not-allowed" }}
											>
												<i className="ti-arrow-left"></i> Prev
											</button>
											<button
												className="site-button button-sm"
												disabled={jobs.pagination?.next ? false : true}
												onClick={() => getData(jobs?.pagination?.next)}
												style={{ backgroundColor: jobs.pagination?.next ? "#1d46f5" : "#8b99d5", cursor: jobs.pagination?.next ? "pointer" : "not-allowed" }}
											>
												Next <i className="ti-arrow-right"></i>
											</button>
										</div>
									</div>
								</div>
								{/* <div className="col-xl-3 col-lg-4 col-md-5">
									<div className="sticky-top">
										<div className="candidates-are-sys m-b30">
											<div className="candidates-bx">
												<div className="testimonial-pic radius"><img src={require('./../../images/testimonials/pic3.jpg')} alt="" width="100" height="100" /></div>
												<div className="testimonial-text">
													<p>I just got a job that I applied for via careerfy! I used the site all the time during my job hunt.</p>
												</div>
												<div className="testimonial-detail"> <strong className="testimonial-name">Richard Anderson</strong> <span className="testimonial-position">Nevada, USA</span> </div>
											</div>
										</div>
										<ul className="company-logo-wg sidebar bg-white job-bx m-b30 clearfix">
											{brandLogo.map((item, index) => (
												<li className="brand-logo" key={index}>
													<Link to={"#"}><img src={item.image} alt="" /></Link>
												</li>
											))}
										</ul>
										<div className="quote-bx">
											<div className="quote-info">
												<h4>Make a Difference with Your Online Resume!</h4>
												<p>Your resume in minutes with JobBoard resume assistant is ready!</p>
												<Link to={"/register"} className="site-button">Create an Account</Link>
											</div>
										</div>
									</div>
								</div> */}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
export default Browsejoblist;